import {faMicrophone} from '@fortawesome/free-solid-svg-icons';

export default [
    {
        to: "/admin/main-stage",
        icon: faMicrophone,
        title: "Main Stage",
    }
];
